import React from 'react';

import PropTypes from 'prop-types';
import _ from 'lodash';
import { Divider, Modal } from '@telus-uds/components-web';
import { useLocalizedStringsContext } from '../../../../context/LocalizedStringsContext';

import OrderHeader from './components/orderHeader';
import OrderSummary from './components/summary';
import OrderAttachments from './components/orderAttachements';
import OrderHistory from './components/orderHistory';
import OrderComments from './components/orderComments';
import OrderActions from './components/orderActions';
import { ModalWidthOverride, StickyOrderModalHeader } from '../../../../design/shared/modalOverrides';

const ViewOrderDetails = ({
  orderData,
  userRights,
  closeViewDetails,
  fetchOrders
}) => {
  const {
    iotOrderDetailsSection: { labelOrderDetails }
  } = useLocalizedStringsContext();
  const { canPerformAction } = userRights;

  const handleClose = () => {
    closeViewDetails(false);
    fetchOrders();
  };

  return (
    <>
      <ModalWidthOverride width="1024px" />
      <StickyOrderModalHeader />
      <Modal
        isOpen
        onClose={handleClose}
        variant={{ width: 'xl' }}
        heading={`${labelOrderDetails} - ${_.get(orderData, 'orderId', '')}`}
      >
        <div style={{ width: "100%", padding: "1rem 0" }}>
        <Divider space={3} variant={{ inverse: true }} />

        <OrderHeader orderData={orderData} userRights={userRights} />
        <Divider space={3} variant={{ inverse: true }} />
        <OrderSummary orderData={orderData} />
        <Divider space={3} variant={{ inverse: true }} />
        <OrderAttachments orderData={orderData} />
        <Divider space={3} variant={{ inverse: true }} />
        <OrderHistory orderData={orderData} />
        <Divider space={3} variant={{ inverse: true }} />
        <OrderComments orderData={orderData} userRights={userRights} />
        <Divider space={3} variant={{ inverse: true }} />
        {canPerformAction && (
          <OrderActions orderData={orderData} fetchOrders={fetchOrders} />
        )}
      </div>
    </Modal>
    </>
  );
};

ViewOrderDetails.propTypes = {
  orderData: PropTypes.shape({}).isRequired,
  userRights: PropTypes.shape({
    canPerformAction: PropTypes.bool
  }).isRequired,
  closeViewDetails: PropTypes.func.isRequired,
  fetchOrders: PropTypes.func.isRequired
};

export default ViewOrderDetails;
